<template>
    <div class="list-group-item">
        <div class="row">
            <div class="col col-md-12">
                <select class="form-control" :class="{'is-invalid': true}" v-model="handler">
                    <option :value="null">Källa</option>
                    <option value="Benify email">Benify email</option>
                    <option value="Epassi email">Epassi email</option>
                    <option value="Webshop Api">Webshop Api</option>
                </select>
                <div class="alert alert-danger" v-if="former.errors && former.errors.handler">
                    {{ former.errors.handler[0] }}
                </div>
            </div>
            <div class="col col-md-12">
                <select class="form-control" :class="{'is-invalid': true}" v-model="affiliate_id">
                    <option :value="null">Försäljningskanal</option>
                    <option :key="'na_' + affiliate.id" :value="affiliate.id" v-for="affiliate in affiliates">{{ affiliate.name }}</option>
                </select>
                <div class="alert alert-danger" v-if="former.errors && former.errors.affiliate_id">
                    {{ former.errors.affiliate_id[0] }}
                </div>
            </div>
            <div class="col col-md-12">
                <input type="text" class="form-control" placeholder="API nyckel" v-model="api_key">
                <div class="alert alert-danger" v-if="former.errors && former.errors.api_key">
                    {{ former.errors.api_key[0] }}
                </div>
            </div>
            <div class="col col-md-12">
                <button class="btn btn-primary" :disabled="poster.submitted" @click="posterPost()">
                     Lägg till
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import poster from '../../shared/mixins/poster'
export default {

    mixins: [
        poster
    ],

    props: {
        product: {
            required: true
        },
        affiliates: {
            required: true
        }
    },

    data () {
        return {
            handler: null,
            affiliate_id: null,
            api_key: '',

            error: false
        }
    },

    computed: {
        posterUrl () {
            return '/products/' + this.product.id + '/apiMap'
        },
        posterData () {
            return {
                handler: this.handler,
                affiliate_id: this.affiliate_id,
                api_key: this.api_key
            }
        }
    },

    methods: {
        posterSuccess () {
            bus.$emit('notify', 'API kopplingen har lagts till.')
            this.$emit('refresh')

            this.handler = null
            this.affiliate_id = null
            this.api_key = ''
        }
    }

}
</script>
